import { render, staticRenderFns } from "./SfCallToAction.vue?vue&type=template&id=3f54a513"
import script from "./SfCallToAction.vue?vue&type=script&lang=js"
export * from "./SfCallToAction.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfCallToAction.vue?vue&type=style&index=0&id=3f54a513&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "5c412264"
  
)

export default component.exports